<div class="browse-requests">
    <section class="hero">
        <h1>Journeys Seeking Support</h1>
        <p class="subtitle">
            These are real people facing cancer, rare diseases, and life-threatening illness.<br>
            Each journey is waiting for your words of encouragement.
        </p>
    </section>

    <section class="filters">
        <!-- Situation pills hidden until category filtering is reliable again. -->
        <!-- <div class="pill-row" role="list">
            <button
                *ngFor="let filter of filters"
                type="button"
                class="pill"
                [class.active]="selectedFilter() === filter.id"
                (click)="setFilter(filter.id)">
                <span class="material-symbols-outlined icon">{{ filter.icon }}</span>
                <span>{{ filter.label }}</span>
            </button>
        </div> -->

        <div class="control-row">
            <div class="dropdown" [class.open]="zoneDropdownOpen">
                <button type="button" class="dropdown-toggle" (click)="toggleZoneDropdown()">
                    <span class="material-symbols-outlined">auto_awesome</span>
                    <span>{{ getSelectedZoneLabel() }}</span>
                    <span class="material-symbols-outlined caret">expand_more</span>
                </button>
                <div class="dropdown-menu" *ngIf="zoneDropdownOpen">
                    <button 
                        *ngFor="let zone of comfortZones" 
                        type="button" 
                        class="dropdown-item"
                        [class.selected]="selectedZone() === zone.id"
                        (click)="selectZone(zone.id)">
                        <span class="material-symbols-outlined">{{ zone.icon }}</span>
                        <span>{{ zone.label }}</span>
                        <span class="material-symbols-outlined check" *ngIf="selectedZone() === zone.id">check</span>
                    </button>
                </div>
            </div>

            <div class="dropdown" [class.open]="sortDropdownOpen">
                <button type="button" class="dropdown-toggle" (click)="toggleSortDropdown()">
                    <span class="material-symbols-outlined">swap_vert</span>
                    <span>{{ getSelectedSortLabel() }}</span>
                    <span class="material-symbols-outlined caret">expand_more</span>
                </button>
                <div class="dropdown-menu" *ngIf="sortDropdownOpen">
                    <button 
                        *ngFor="let option of sortOptions" 
                        type="button" 
                        class="dropdown-item"
                        [class.selected]="selectedSort() === option.id"
                        (click)="selectSort(option.id)">
                        <span>{{ option.label }}</span>
                        <span class="material-symbols-outlined check" *ngIf="selectedSort() === option.id">check</span>
                    </button>
                </div>
            </div>
        </div>
    </section>

    <section class="content">
        <div class="requests-grid" *ngIf="viewMode() === 'grid'">
            <!-- Share Your Journey Card -->
            <a class="request-card share-journey" routerLink="/request-support">
                <div class="card-body">
                    <div class="icon-wrap">
                        <span class="material-symbols-outlined">favorite</span>
                    </div>
                    <h3>Share Your Journey</h3>
                    <p>Going through something difficult? Let us connect you with support.</p>
                    <span class="pill-cta">
                        <span class="material-symbols-outlined">favorite</span>
                        You're Not Alone
                    </span>
                </div>
            </a>

            <a class="request-card" *ngFor="let request of sortedRequests()" [routerLink]="['/request', request.id]">
                <div class="card-header">
                    <div class="avatar">{{ getDisplayName(request).charAt(0) }}</div>
                    <div class="identity">
                        <div class="name-row">
                            <span class="name">{{ getDisplayName(request) }}</span>
                            <span class="age" *ngIf="request.age">{{ request.age }}</span>
                        </div>
                        <div class="location">
                            <span class="material-symbols-outlined">location_on</span>
                            {{ request.location }}
                        </div>
                    </div>
                </div>

                <div class="diagnosis-badge" *ngIf="request.diagnosis">
                    <span class="material-symbols-outlined">{{ getDiagnosisIcon(request.diagnosis) }}</span>
                    {{ request.diagnosis }}
                </div>

                <p class="message">{{ request.additionalNote }}</p>

                <div class="stats">
                    <span class="stat hearts">
                        <span class="material-symbols-outlined">favorite</span>
                        {{ getHeartCount(request) }}
                    </span>
                    <span class="stat messages">
                        <span class="material-symbols-outlined">mail</span>
                        {{ request.supportCount }}
                    </span>
                    <span class="stat time">
                        <span class="material-symbols-outlined">schedule</span>
                        {{ getTimeAgo(request.createdAt) }}
                    </span>
                </div>
            </a>

            <a class="request-card request-card--anyone" routerLink="/send-to-anyone">
                <div class="card-header">
                    <div class="avatar avatar--anyone">
                        <span class="material-symbols-outlined">public</span>
                    </div>
                    <div class="identity">
                        <div class="name-row">
                            <span class="name">Anyone Who Needs It</span>
                        </div>
                        <div class="location">
                            <span class="material-symbols-outlined">location_on</span>
                            Everywhere
                        </div>
                    </div>
                </div>

                <div class="diagnosis-badge diagnosis-badge--open">
                    <span class="material-symbols-outlined">stars</span>
                    Always Open
                </div>

                <p class="message">
                    Not sure who to support? Send a message of hope to someone who needs it. We'll match it with a person going through a tough time.
                </p>

                <div class="stats">
                    <!-- <span class="stat hearts">
                        <span class="material-symbols-outlined">favorite</span>
                        12
                    </span> -->
                    <span class="stat messages">
                        <span class="material-symbols-outlined">mail</span>
                        400+ cards
                    </span>
                    <span class="stat time stat--open">Always Open</span>
                </div>
            </a>

        </div>

        <div class="empty" *ngIf="!loading() && sortedRequests().length === 0 && hasActiveFilters()">
            <p>No journeys match this filter.</p>
            <button type="button" (click)="resetFilters()">Show all</button>
        </div>
    </section>

    <section class="cta">
        <h2>Going Through Something?</h2>
        <p>You don't have to face it alone. Share your story and receive support from people who care.</p>
        <button routerLink="/request-support" type="button">Share Your Story</button>
    </section>

    <section class="help-section">
        <div class="help-content">
            <div class="help-left">
                <span class="material-symbols-outlined heart">favorite</span>
                <div class="help-text">
                    <span class="help-title">Help us keep spreading hope</span>
                    <span class="help-subtitle">Your support helps us connect more people with the encouragement they need.</span>
                </div>
            </div>
            <a href="#FUNTHRZKBWU" class="donate-link">
                <span class="material-symbols-outlined">favorite_border</span>
                Donate
            </a>
        </div>
    </section>
</div>
